import {useEffect, useState} from "react";
import {useShouldShowHintKey} from "../hints/HintManager";

const hints = [
  `to select multiple cards, hover over a card and click the selection icon. You can also press 'b' to select a card.`,
  `press 'space' to assign the card below your mouse cursor to yourself. If it was already assigned, you can use 'space' to start/pause the card.`,
  `update card effort quickly by hovering your mouse cursor over the effort icon and pressing a number key on your keyboard.`,
  `update card priority quickly by hovering your mouse cursor over the priority icon and pressing a number key on your keyboard.`,
  `use "Go to card" to jump to any search result directly from the search bar.`,
  `press "?" to view all available shortcuts in Codecks.`,
  `you can directly paste images here from your clipboard. This also works for comments.`,
  `you can add image backgrounds to any card. Use the eye icon in the attachments section to change the background in case you have multiple image attachments.`,
  `you can add subcards to a card by dragging a card onto the opened card.`,
  `drag'n'drop is supported for most actions in Codecks. Try it out!`,
  `you can sort by mutliple criteria by holding CTRL/CMD on your keyboard when clicking on the ordering options.`,
  `when selecting multiple cards, you can use the powerful bulk action bar to apply property changes to many cards at once.`,
  `you can associate emojis or colors with tags. Check out the projects tags view to do that.`,
  `you can collect feedback directly from Discord by adding our trusty Decky bot to your discord server.`,
  `you can share any project with your community by using the "Open Decks" feature in the project settings.`,
  `the progress bar of a hero card shows you the amount and effort of all its sub cards at a glance.`,
  `you can use due dates to keep important dates in mind. A card may have a due date and a milestone at the same time.`,
  `use the text "- [ ]" to insert checklists in your card text. If you add a checklist there will be a progress bar near the bottom of the card.`,
  `done cards are automatically archived after a set time. You can customize how long that takes in your Organization Settings.`,
];

const getRandomHint = (): string => {
  const now = new Date();
  const min = now.getMinutes() + now.getHours() * 60;
  return `Quick tip: ${hints[min % hints.length]}`;
};

const hintKey = "welcome.waitingForCreateHints";

export const useCreationHint = ({root}: {root: any}): string | null => {
  const meId = root.loggedInUser?.$meta.get("id", null);
  const [waitingForCreateHints, dismiss] = useShouldShowHintKey(hintKey) as [boolean, () => void];
  const getEnabled = () => {
    if (!waitingForCreateHints) return true;
    if (!meId) return false;
    const eventCount = root.account.$meta.count("activities", {changerId: meId});
    return eventCount > 50;
  };
  const enabled = getEnabled();
  useEffect(() => {
    if (enabled && waitingForCreateHints) {
      dismiss();
    }
  }, [enabled, waitingForCreateHints, dismiss]);

  const [hint] = useState(getEnabled() ? getRandomHint : null);
  return hint;
};
